<template>
  <div style="height: 204px; background: transparent;">
    <div :class="{ sticky: isSticky }" class="out-head">
      <div id="header">
        <div id="inheader">
          <div class="top clearfix">
            <div id="logo">
              <a href="/" target="_self"><img src="~@/assets/images/logo.png" /></a>
            </div>
            <div class="top_tr">
              <a id="top_d" v-html="time"></a>&nbsp;&nbsp;&nbsp;&nbsp;<a @click="setHomePage"
                style="cursor: pointer">设为首页</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a @click="addFavorite"
                style="cursor: pointer">收藏本站</a>
            </div>
          </div>
        </div>
      </div>
      <div class="header_nav">
        <ul class="nav">
          <li v-for="(item, index) in menus" :key="index" @mouseenter="showMenu(index)" @mouseleave="showMenu(-1)">
            <a :class="{ on: item.params.includes(urlParams) }" href="javascript:void(0)"
              @click="toggleFirstMenu(item.id, item.menuUrl)">{{ item.menuName }}</a>
            <ul class="subnav" :style="{ display: currIndex === index ? 'block' : 'none' }">
              <li v-for="inItem in item.menuVOS" :key="inItem.menuName">
                <a href="javascript:void(0)" @click="toggleSecondMenu(item.id, inItem.id, inItem.menuUrl)">
                  {{
                    inItem.menuName }}</a>
              </li>
            </ul>
          </li>
        </ul>

        <div class="shadow"></div>
      </div>
    </div>
  </div>

</template>

<script setup>
import { getMenus } from "@/api/home";
import { getCurrentInstance, ref } from "vue";
import { useRouter, useRoute } from "vue-router";
import { watch, onMounted, onUnmounted } from "vue";
const router = useRouter();
const route = useRoute();
const { proxy } = getCurrentInstance();
let menus = ref([]);
let currIndex = ref(0);
let urlParams = ref("");

// 用于跟踪导航栏是否应该固定
const isSticky = ref(false);

// 滚动处理函数
const handleScroll = () => {
  // 获取滚动距离（兼容各浏览器）
  const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
  // 设定阈值：滚动超过100px时固定（可根据需求调整）
  const threshold = 0;

  // 平滑切换固定状态
  if (scrollTop > threshold && !isSticky.value) {
    isSticky.value = true;
  } else if (scrollTop <= threshold && isSticky.value) {
    isSticky.value = false;
  }
};

// 挂载时添加滚动监听
onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

// 卸载时移除滚动监听，防止内存泄漏
onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

function showMenu(index) {
  currIndex.value = index;
}

let firstId = ref("first7");

watch(
  () => route.query,
  (query, oldValue) => {
    const url = window.location.href;
    if (Object.keys(query).length === 0) {
      setTimeout(() => {
        let articleParams = "";
        if (url.includes("detail")) {
          articleParams = JSON.parse(sessionStorage.getItem("articleParams"));
        }

        console.log("articleParams", articleParams);
        urlParams.value = articleParams ? articleParams : "/";
      }, 100);
    } else {
      urlParams.value = window.location.search.substring(1);
    }

    // console.log("urlParams.value-=-==", urlParams.value);
  },
  {
    immediate: true,
  }
);

// 获取时间
let time = getDate();

function getDate() {
  var mydate = new Date();
  var str = "" + mydate.getFullYear() + "年";
  str += mydate.getMonth() + 1 + "月";
  str += mydate.getDate() + "日";
  str += "&nbsp;&nbsp;星期";
  str += "天一二三四五六".charAt(mydate.getDay());
  return str;
}

// 添加收藏
function addFavorite() {
  var ctrl =
    navigator.userAgent.toLowerCase().indexOf("mac") != -1
      ? "Command/Cmd"
      : "CTRL";
  if (document.all) {
    window.external.addFavorite("/", "天津市测绘与地理信息协会");
  } else if (window.sidebar) {
    window.sidebar.addPanel("天津市测绘与地理信息协会", "/", "");
  } else {
    alert("您可以尝试通过快捷键" + ctrl + " + D 加入到收藏夹~");
  }
  return false;
}

function setHomePage() {
  try {
    if (document.all) {
      // IE
      document.body.style.behavior = "url(#default#homepage)";
      document.body.setHomePage(window.location.href);
    } else if (window.sidebar && window.sidebar.addPanel) {
      // Firefox
      alert('请手动设置：点击浏览器菜单中的"书签"→"添加到书签"→"设为首页"');
    } else {
      alert("您的浏览器不支持自动设置首页，请手动在浏览器设置中进行操作。");
    }
  } catch (e) {
    alert("设置失败：" + e.message);
  }
}

function toggleFirstMenu(id, url) {
  if (id == 7) {
    router.push("/");
  } else {
    router.push("/detail?" + url);
  }
}

function toggleSecondMenu(pid, subId, url) {
  firstId.value = "first" + pid;
  console.log("url", url);
  router.push("/detail?" + url);
}
function getHomeMenus() {
  getMenus().then((res) => {
    if (res.code == 200 && res.data) {
      menus.value = res.data.map((item) => {
        const params = item.menuVOS
          ? item.menuVOS.map((inItem) => inItem.menuUrl)
          : [item.menuUrl];
        return {
          ...item,
          params,
        };
      });
      console.log("menus", menus.value);
    } else {
      proxy.$message.error(res.message);
    }
  });
}
getHomeMenus();
</script>

<style lang="scss" scoped>
.out-head {
  transition: all 0.3s ease-in-out;
  /* 缓动过渡（时长可调整） */
  position: static;
  /* 默认静态定位 */
  top: 0;
  width: 100%;
  /* 固定时撑满宽度 */
  z-index: 999;


  /* 固定时加背景，防止透底 */
  &.sticky {
    position: fixed;
    top: 0;

  }

  .header_nav {
    transition: all 0.2s ease;
  }
}
</style>
